import React from "react";
import { useTranslation } from "react-i18next";
import "./index.less";
const AdvantageList = (props) => {
  const { t } = useTranslation();
  console.log(props);
  const { advantageData = [], position = "top" } = props;
  return (
    <div className="feature-item-warp">
      {advantageData.map((item, index) => (
        <div className="item" key={"advantageData" + index}>
          {position === "top" && (
            <div>
              <div className="label">{t(item?.label)}</div>
              <div
                className="count"
                dangerouslySetInnerHTML={{ __html: t(item?.value) }}
              ></div>
            </div>
          )}
          {position === "bottom" && (
            <div>
              <div
                className="count"
                dangerouslySetInnerHTML={{ __html: t(item?.value) }}
              ></div>
              <div className="label">{t(item?.label)}</div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export { AdvantageList };
